var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("panel-competition-form-box", [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "form__headline mab16" }, [
            _vm._v("Zawody cykliczne"),
          ]),
          _c("p", { staticClass: "mab8" }, [
            _vm._v(
              " Umieszczenie zawodów w cyklu pozwala uczestnikom na jednoczesną rejestrację we wszystkich zawodach w danej serii. Opłata za udział może uwzględniać rabat za jednoczesną rejestrację w wielu zawodach z cyklu. "
            ),
          ]),
        ]),
      ]),
      _c("panel-competition-form-box", { staticClass: "mat16" }, [
        _c("div", { staticClass: "col-12 col-lg-7" }, [
          _c(
            "div",
            { staticClass: "cycle-mode-option" },
            [
              _c("panel-input-base-radio", {
                attrs: {
                  name: "cycle-mode",
                  option: {
                    value: "existing",
                    title: "Dodaj zawody do istniejącego cyklu",
                  },
                },
                model: {
                  value: _vm.form.mode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "mode", $$v)
                  },
                  expression: "form.mode",
                },
              }),
              _vm.form.mode === "existing"
                ? _c(
                    "div",
                    { staticClass: "cycle-mode-option__field" },
                    [
                      _c("p", { staticClass: "form-input__label" }, [
                        _vm._v("Wybierz istniejący cykl"),
                      ]),
                      _c("base-input-select", {
                        attrs: {
                          "is-panel": "",
                          placeholder: "Wpisz nazwę cyklu",
                          "label-select": "name",
                          options: _vm.cycleOptions,
                          reduce: (item) => item.id,
                          error: _vm.errors.id || _vm.errors.cycle,
                        },
                        model: {
                          value: _vm.form.selectedCycleId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "selectedCycleId", $$v)
                          },
                          expression: "form.selectedCycleId",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "cycle-mode-option" },
            [
              _c("panel-input-base-radio", {
                attrs: {
                  name: "cycle-mode",
                  option: { value: "create", title: "Stwórz nowy cykl" },
                },
                model: {
                  value: _vm.form.mode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "mode", $$v)
                  },
                  expression: "form.mode",
                },
              }),
              _vm.form.mode === "create"
                ? _c(
                    "div",
                    { staticClass: "cycle-mode-option__field" },
                    [
                      _c("panel-input-text", {
                        attrs: {
                          label: "Nazwa nowego cyklu",
                          hint: "Wpisz nazwę cyklu",
                          error: _vm.errors.id,
                        },
                        on: {
                          "update:error": function ($event) {
                            return _vm.$set(_vm.errors, "id", $event)
                          },
                        },
                        model: {
                          value: _vm.form.newCycleName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "newCycleName", $$v)
                          },
                          expression: "form.newCycleName",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm.isJoiningExistingCycle
        ? _c("panel-competition-form-box", { staticClass: "mat16" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "p",
                {
                  staticClass: "form-input__hint",
                  staticStyle: { "margin-top": "0" },
                },
                [
                  _vm._v(
                    " Ustawienia rabatów należą do cyklu i wczytają się po zapisaniu przypisania. Edycja zniżek jest wspólna dla wszystkich zawodów w serii. "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm.hasCycleSettings
        ? [
            _c("panel-competition-form-box", { staticClass: "mat16" }, [
              _c(
                "div",
                { staticClass: "col-12 col-lg-7" },
                [
                  _c("p", { staticClass: "form-input__label mab16" }, [
                    _vm._v(
                      "Możliwość przenoszenia rejestracji po dokonaniu opłaty"
                    ),
                  ]),
                  _c("panel-input-base-radio", {
                    attrs: {
                      value: _vm.moveRegistrationValue,
                      name: "move-registration",
                      option: { value: "yes", title: "Tak" },
                    },
                    on: { input: _vm.setMoveRegistration },
                  }),
                  _c("panel-input-base-radio", {
                    attrs: {
                      value: _vm.moveRegistrationValue,
                      name: "move-registration",
                      option: { value: "no", title: "Nie" },
                    },
                    on: { input: _vm.setMoveRegistration },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "col-12 col-lg-4" }, [
                _c("p", { staticClass: "form-input__hint" }, [
                  _vm._v(
                    " Uczestnicy mogą przenieść swoją rejestrację do innych zawodów w cyklu nawet po opłaceniu startu. Różnica w opłacie nie zostanie wyrównana. "
                  ),
                ]),
              ]),
            ]),
            _c("panel-competition-form-box", { staticClass: "mat16" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("p", { staticClass: "form-input__label mab8" }, [
                  _vm._v("Rabaty dla opłat startowych w cyklu"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "col-12 col-lg-7" },
                [
                  _c("div", { staticClass: "discount-headers mab8" }, [
                    _c("span", { staticClass: "discount-headers__starts" }, [
                      _vm._v(
                        "Liczba startów od której zostanie naliczany rabat"
                      ),
                    ]),
                    _c("span", { staticClass: "discount-headers__amount" }, [
                      _vm._v("Rabat zł"),
                    ]),
                    _c("span", {
                      staticClass: "discount-headers__trash",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]),
                  _vm._l(_vm.form.discountRows, function (row, index) {
                    return _c(
                      "div",
                      {
                        key: `discount-${index}`,
                        staticClass: "discount-row",
                        class: {
                          "discount-row--error": _vm.isDuplicateStarts(index),
                        },
                      },
                      [
                        _c("div", { staticClass: "discount-stepper" }, [
                          _c(
                            "button",
                            {
                              staticClass: "discount-stepper__btn",
                              attrs: {
                                type: "button",
                                disabled: !_vm.canChangeStarts(index, -1),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeStarts(index, -1)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fas fa-minus" })]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: row.starts,
                                expression: "row.starts",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "discount-stepper__input",
                            attrs: { type: "number", min: "2" },
                            domProps: { value: row.starts },
                            on: {
                              blur: [
                                function ($event) {
                                  return _vm.normalizeStarts(index)
                                },
                                function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              ],
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  row,
                                  "starts",
                                  _vm._n($event.target.value)
                                )
                              },
                            },
                          }),
                          _c(
                            "button",
                            {
                              staticClass: "discount-stepper__btn",
                              attrs: {
                                type: "button",
                                disabled: !_vm.canChangeStarts(index, 1),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeStarts(index, 1)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fas fa-plus" })]
                          ),
                        ]),
                        _c("span", { staticClass: "discount-row__label" }, [
                          _vm._v("liczba startów"),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: row.amount,
                              expression: "row.amount",
                            },
                          ],
                          staticClass: "discount-row__amount",
                          attrs: {
                            type: "text",
                            inputmode: "decimal",
                            placeholder: "0",
                          },
                          domProps: { value: row.amount },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(row, "amount", $event.target.value)
                            },
                          },
                        }),
                        _c(
                          "button",
                          {
                            staticClass: "discount-row__trash",
                            attrs: { type: "button", title: "Usuń próg" },
                            on: {
                              click: function ($event) {
                                return _vm.removeDiscountRow(index)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fas fa-trash" })]
                        ),
                      ]
                    )
                  }),
                  _vm.hasDuplicateStarts
                    ? _c("p", { staticClass: "discount-error mat8" }, [
                        _vm._v(
                          " Każdy próg musi mieć unikalną liczbę startów. "
                        ),
                      ])
                    : _vm._e(),
                  _vm.isDiscountLimitReached
                    ? _c("p", { staticClass: "discount-error mat8" }, [
                        _vm._v(
                          " Możesz dodać maksymalnie " +
                            _vm._s(_vm.maxDiscounts) +
                            " progów rabatowych. "
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "discount-add mat8" },
                    [
                      _c(
                        "base-button",
                        {
                          attrs: {
                            btn2: "",
                            short: "",
                            disabled: _vm.isDiscountLimitReached,
                          },
                          on: { click: _vm.addDiscountRow },
                        },
                        [_vm._v(" Dodaj nowy próg ")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c("div", { staticClass: "col-12 col-lg-4" }, [
                _c("p", { staticClass: "form-input__hint" }, [
                  _vm._v(
                    " Ustal progi liczby startów i odpowiadające im kwoty rabatów do opłaty startowej."
                  ),
                  _c("br"),
                  _c("br"),
                  _vm._v(
                    " Wpisana kwota rabatu zmniejsza każdą opłatę startową w cyklu, nie sumę wszystkich opłat. Rabaty są wspólne dla całego cyklu — maksymalnie " +
                      _vm._s(_vm.maxDiscounts) +
                      " progów. "
                  ),
                ]),
              ]),
            ]),
            _c("panel-competition-form-box", { staticClass: "mat16" }, [
              _c(
                "div",
                { staticClass: "col-12 col-lg-7" },
                [
                  _c("p", { staticClass: "form-input__label" }, [
                    _vm._v(" Data zakończenia uwzględniania rabatów "),
                    _c("span", { staticClass: "form-input__label--positive" }, [
                      _vm._v("(opcjonalnie)"),
                    ]),
                  ]),
                  _c("base-input-date", {
                    staticClass: "form-input__date mat8",
                    attrs: {
                      "is-short": "",
                      border: "",
                      hint: "Wybierz",
                      placeholder: "DD.MM.RRRR",
                      error: _vm.errors.discountEndedDate,
                    },
                    model: {
                      value: _vm.form.discountEndedDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "discountEndedDate", $$v)
                      },
                      expression: "form.discountEndedDate",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "col-12 col-lg-4" }, [
                _c("p", { staticClass: "form-input__hint" }, [
                  _vm._v(
                    "Nie wybieraj daty aby rabaty były dostępne cały czas."
                  ),
                ]),
              ]),
            ]),
          ]
        : _vm._e(),
      _c("div", { staticClass: "col-lg-12 mat16 mab64" }, [
        _c(
          "div",
          {
            staticClass: "row",
            class: _vm.assignedCycleId
              ? "justify-content-between"
              : "justify-content-end",
          },
          [
            _vm.assignedCycleId
              ? _c(
                  "div",
                  { staticClass: "col-12 col-lg-4 cycle-actions__detach" },
                  [
                    _c(
                      "base-button",
                      {
                        attrs: {
                          btn2: "",
                          loading: _vm.loading,
                          disabled: _vm.loading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("detach")
                          },
                        },
                      },
                      [_vm._v(" Odepnij zawody od cyklu ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-12 col-lg-4" },
              [
                _c(
                  "base-button",
                  {
                    attrs: {
                      btn1: "",
                      loading: _vm.loading,
                      disabled:
                        _vm.loading || _vm.hasDuplicateStarts || !_vm.canSave,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("save")
                      },
                    },
                  },
                  [_vm._v(" Zapisz ")]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }